<template>
  <PSUPage appRoles="Y" additionalIdentity="Y" loginRequired="Y">
    <template #title>
      <span class="title-thin">About</span><span class="title-bold">Me</span>
    </template>

    <template #nav>
      <NavLinks :nudges="nudges" />
    </template>

    <template #nudge v-if="nudges.length">
      Please complete all forms highlighted in the navigation
    </template>

    <template #view>
      <router-view @formSubmitted="clear_nudge" />
    </template>

  </PSUPage>
</template>

<script>
import NavLinks from "./components/NavLinks.vue"
import _ from 'lodash'

export default {
  name: 'App',
  
  components: { NavLinks },

  data: () => ({
    'back': null,
    'nudges': [],
  }),

  computed: {
    back_name() {
      if (!this.back || !this.back_choices[this.back]) {
        return ""
      }
      
      return this.back_choices[this.back].name
    },

    back_url() {
      if (!this.back || !this.back_choices[this.back]) {
        return ""
      }

      if (this.$envName == 'prod') {
        return this.back_choices[this.back].prod_url
      }
      
      return this.back_choices[this.back].stage_url
        
    },
  },

  methods: {
    clear_nudge(form) {
      _.pull(this.nudges, form)
    }
  },

  async created() {
    await this.$router.isReady()
    let query = this.$router.currentRoute.value.query
    let nudge_options = {
      'contact': ['address-form', 'external-email-form', 'sogi-form', 'veteran-form']
    }

    if (query.nudge && nudge_options[query.nudge]) {
      this.nudges = nudge_options[query.nudge]
    }
  }
}
</script>

<style>
.error {
    width: 100%;
    background: #B30000;
    color: white;
}

.note {
    color: #555;
    max-width: 40rem;
    text-align: start;
}

.input_note {
    color: #555;
    max-width: 25rem;
}
</style>
